import { Breakpoints, styled } from "@vw-marketing/us-components";

export const CardContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding: ${theme.size.dynamic0100} 26px;
      width: ${theme.size.grid020};
      
      @media (min-width: ${Breakpoints.b560 + 1}px) and (max-width: ${Breakpoints.b960}px) {
        padding: ${theme.size.dynamic0100} 46px;
      }
      
      @media (min-width: ${Breakpoints.b960 + 1}px) and (max-width: ${Breakpoints.b1280 - 1}px) {
        padding: ${theme.size.dynamic0100} 80px;
      }
      
      @media (min-width: ${Breakpoints.b1280}px) {
        padding: 0;
        width: ${theme.size.grid007};
      }
      
      @media (min-width: ${Breakpoints.b1600}px) {
        width: ${theme.size.grid006};
      }
    `;
  }}
`;

export const StyledLogoWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      justify-content: start;
      padding-bottom: ${theme.size.dynamic0050};
      width: 100%;

      img {
        max-height: ${theme.size.dynamic0200};
        max-width: ${theme.size.grid002};
      }
    `;
  }}

`;

export const StyledModelMsrpWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      color: #FFF;
      display: flex;
      justify-content: space-between;
      padding-bottom: ${theme.size.dynamic0050};
    `;
  }}
`;

export const StyledModelContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      gap: ${theme.size.static0};
    `;
  }}
`;

export const StyledModelTrimContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-content: flex-start;
      align-items: center;
      align-self: stretch;
      display: flex;
      flex-wrap: wrap;
      gap: ${theme.size.static100};
    `;
  }}
`;

export const StyledMsrpContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-end;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static0};

      @media(max-width: ${Breakpoints.b1920}px){
        gap: 3px;
      }
    `;
  }}
`;

export const StyledOfferDetailsWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      color: #FFF;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static0};

      @media(min-width: ${Breakpoints.b960}px) and (max-width: ${Breakpoints.b1280}px) {
        gap: ${theme.size.grid001};
        flex-direction: row;
      }
    `;
  }}
`;

export const StyledOfferTermsAndHighlightContainer: any = styled.div`
  ${({ }) => {
    return `
      align-self: stretch;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      
      @media(min-width: ${Breakpoints.b560}px) and (max-width: ${Breakpoints.b1280}px) {
        flex-basis: 50%;
      }
    `;
  }}
`

export const StyledPaymentTermsContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-wrap: wrap;
      gap: ${theme.size.dynamic0100};
      padding-bottom: ${theme.size.dynamic0020};
    `;
  }}
`;

export const StyledOfferPaymentDetailsContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static0};
    `;
  }}
`

export const StyledOfferPriceContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      align-items: start;
      gap: ${theme.size.static100};
    `;
  }}
`

export const StyledOfferTermContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static0};
    `;
  }}
`

export const StyledOfferTimeContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      align-items: start;
      gap: ${theme.size.static100};
    `;
  }}
`

export const StyledOfferTitleContainer: any = styled.div`
  ${() => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
    `;
  }}
`;

export const StyledOfferHightlight = styled.div`
  ${({ theme }) => `
    align-items: center;
    align-self: stretch;
    display: flex;
    gap: ${theme.size.dynamic0020};
    padding-bottom: ${theme.size.dynamic0100};
  `}
`;

export const StyledOfferMaterialInfoWrapper = styled.div`
  ${() => {
    return `
      display: flex;
      flex-direction: column;

      @media(min-width: ${Breakpoints.b560}px) and (max-width: ${Breakpoints.b1280}px) {
        flex-basis: 50%;
      }
    `;
  }}
`;

export const StyledOfferMaterialInfo = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      color: #DFE4E8;
      display: flex;
      padding-bottom: ${theme.size.dynamic0050};
    `;
  }}
`;

export const StyledTimeExpiry = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      align-self: stretch;
      color: #FFFFFF;
      display: flex;
      gap:${theme.size.static150};
      justify-content: flex-start;
      padding-bottom: ${theme.size.static200};

      @media (max-width: 559px) {
        padding-bottom: 0;
      }

      p {
        padding-top: 2px;      
      }
    `;
  }}
`;

export const StyledOffersCTAWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      gap: ${theme.size.static300};
      padding-top: ${theme.size.dynamic0050};

      @media(max-width: ${Breakpoints.b960}px) {
        flex-direction: column;
        justify-content: center;
        padding-top: ${theme.size.dynamic0100};
      }
    `;
  }}
`;

export const StyledButtonContainer: any = styled.div`
  button:hover {
    background: ${({ theme }) => theme.colors.accent.nbab.default};
    color: rgb(0, 30, 80);
  }

  button {
    &:active,
    &:focus {
      background: ${({ theme }) => theme.colors.accent.offer.default} !important;
      color: rgb(0, 30, 80) !important;
    }
  }
`;

export const StyledLinkButtonContainer: any = styled.div`
  ${({ theme }) => {
    return `
      a:hover {
        color: ${theme.colors.accent.nbab.default};
      }

      a {
        color: white;
      }
    `;
  }}
`;

